import React from "react";

export default function EnterBankDetails() {
  return (
    <div>
      <p>EnterBankDetails</p>
    </div>
  );
}
